import { render, staticRenderFns } from "./general-failure.vue?vue&type=template&id=0e7b884b&scoped=true"
import script from "./general-failure.vue?vue&type=script&lang=js"
export * from "./general-failure.vue?vue&type=script&lang=js"
import style0 from "./general-failure.scss?vue&type=style&index=0&id=0e7b884b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7b884b",
  null
  
)

export default component.exports